export const WHEN_OPTIONS = {
  'NEXT_WEEK': 'Next week',
  'NEXT_MONTH': 'Next month',
  'IN_3_MONTHS': 'In 3 months',
  'IN_6_MONTHS': 'In 6 months',
  'IN_12_MONTHS': 'In 12 months',
}